import React from 'react';

import PropTypes from 'prop-types';

import BaseParameters from '../base/components/BaseParameters';
import { createFieldRegistry } from '../base/components/FieldRegistry';

const Parameters = ({ algorithmOptions, control, disabled, setValue }) => {
    const fields = createFieldRegistry({ control, disabled, setValue });

    const fieldsMappingByAlgorithm = {
        static_api_key: [
            fields.fileRate,
            fields.downPayment,
            fields.amountLimit,
            fields.powerLimit,
        ],
        static_payment: [
            fields.commissionCredit,
            fields.downPayment,
            fields.amountLimit,
            fields.powerLimit,
        ],
        static_payment_tax: [
            fields.commissionCredit,
            fields.downPayment,
            fields.amountLimit,
            fields.powerLimit,
        ],
    };

    return (
        <BaseParameters
            control={control}
            disabled={disabled}
            setValue={setValue}
            algorithmOptions={algorithmOptions}
            fieldsMappingByAlgorithm={fieldsMappingByAlgorithm}
        />
    );
};

Parameters.propTypes = {
    algorithmOptions: PropTypes.array,
    control: PropTypes.object,
    disabled: PropTypes.bool,
    setValue: PropTypes.func,
};

export default Parameters;
